import React from "react";
import { Link } from "react-router-dom";
import { PERFORMANCE_LOG_BASE_URL } from "../../util/contants/url_constants";

const TourCard = ({ tour, onMoreInfo, onPhotos, onVideo }) => {
  if (!tour) return null;

  const {
    description,
    date,
    dateText,
    performances,
    photos,
    video,
    moreInfo,
    _id,
  } = tour;

  const formatDateRange = () => {
    if (dateText) return dateText;
    if (!performances || performances.length === 0) return "";

    const firstPerf = performances[0];
    const lastPerf = performances[performances.length - 1];

    if (!firstPerf?.asset?.startDate || !lastPerf?.asset?.endDate) return "";

    const startDate = firstPerf.asset.startDate;
    const endDate = lastPerf.asset.endDate;

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const startMonth = monthNames[startDate.month - 1];
    const endMonth = monthNames[endDate.month - 1];

    if (startDate.year === endDate.year && startDate.month === endDate.month) {
      return `${startMonth} ${startDate.day}-${endDate.day}, ${startDate.year}`;
    } else if (startDate.year === endDate.year) {
      return `${startMonth} ${startDate.day}-${endMonth} ${endDate.day}, ${startDate.year}`;
    } else {
      return `${startMonth} ${startDate.day}, ${startDate.year}-${endMonth} ${endDate.day}, ${endDate.year}`;
    }
  };

  const getLocation = () => {
    if (performances && performances.length > 0) {
      const locations = performances
        .map((perf) => perf.asset?.location)
        .filter((loc) => loc)
        .filter((loc, index, arr) => arr.indexOf(loc) === index); // Remove duplicates

      if (locations.length > 0) {
        return locations.length === 1 ? locations[0] : locations.join(" & ");
      }
    }

    return "USA";
  };

  const handleMoreInfo = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (moreInfo && moreInfo.trim().length && onMoreInfo) {
      onMoreInfo(tour);
    }
  };

  const handlePhotos = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (photos && photos.length && onPhotos) {
      onPhotos(tour);
    }
  };

  const handleVideo = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (video && onVideo) {
      onVideo(video);
    }
  };

  const hasItinerary = performances && performances.length > 0;
  const hasMoreInfo = moreInfo && moreInfo.trim().length;
  const hasPhotos = photos && photos.length > 0;
  const hasVideo = video;

  return (
    <div className="tour-card">
      <div className="tour-card-content">
        <div className="tour-title">{description || "Tour"}</div>

        <div className="tour-location">{getLocation()}</div>

        <div className="tour-dates-row">
          <div className="tour-dates">{formatDateRange()}</div>
          {hasItinerary && (
            <Link
              to={`${PERFORMANCE_LOG_BASE_URL}${_id}`}
              className="tour-itinerary-btn"
            >
              ITINERARY
            </Link>
          )}
        </div>

        {/* {(hasMoreInfo || hasPhotos || hasVideo) && (
          <div className="tour-actions">
            {hasMoreInfo && (
              <button className="tour-action-btn" onClick={handleMoreInfo}>
                MORE INFO
              </button>
            )}
            
            {hasPhotos && (
              <button className="tour-action-btn" onClick={handlePhotos}>
                PHOTOS
              </button>
            )}
            
            {hasVideo && (
              <button className="tour-action-btn" onClick={handleVideo}>
                VIDEO
              </button>
            )}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default TourCard;
